export const LOAD_SUPPLIER_MASTER_REQUEST = "LOAD_SUPPLIER_MASTER_REQUEST";
export const LOAD_SUPPLIER_MASTER_SUCCESS = "LOAD_SUPPLIER_MASTER_SUCCESS";
export const LOAD_SUPPLIER_MASTER_FAIL = "LOAD_SUPPLIER_MASTER_FAIL";

export const ALL_SUPPLIER_MASTER_REQUEST = "ALL_SUPPLIER_MASTER_REQUEST";
export const ALL_SUPPLIER_MASTER_SUCCESS = "ALL_SUPPLIER_MASTER_SUCCESS";
export const ALL_SUPPLIER_MASTER_FAIL = "ALL_SUPPLIER_MASTER_FAIL";

export const LOAD_COSTING_MASTER_REQUEST = "LOAD_COSTING_MASTER_REQUEST";
export const LOAD_COSTING_MASTER_SUCCESS = "LOAD_COSTING_MASTER_SUCCESS";
export const LOAD_COSTING_MASTER_FAIL = "LOAD_COSTING_MASTER_FAIL";

export const ALL_COSTING_MASTER_REQUEST = "ALL_COSTING_MASTER_REQUEST";
export const ALL_COSTING_MASTER_SUCCESS = "ALL_COSTING_MASTER_SUCCESS";
export const ALL_COSTING_MASTER_FAIL = "ALL_COSTING_MASTER_FAIL";

export const LOAD_PRODUCT_MASTER_REQUEST = "LOAD_PRODUCT_MASTER_REQUEST";
export const LOAD_PRODUCT_MASTER_SUCCESS = "LOAD_PRODUCT_MASTER_SUCCESS";
export const LOAD_PRODUCT_MASTER_FAIL = "LOAD_PRODUCT_MASTER_FAIL";

export const ALL_PRODUCT_MASTER_REQUEST = "ALL_PRODUCT_MASTER_REQUEST";
export const ALL_PRODUCT_MASTER_SUCCESS = "ALL_PRODUCT_MASTER_SUCCESS";
export const ALL_PRODUCT_MASTER_FAIL = "ALL_PRODUCT_MASTER_FAIL";

//grade master
export const ALL_GRADE_MASTER_REQUEST = "ALL_GRADE_MASTER_REQUEST";
export const ALL_GRADE_MASTER_SUCCESS = "ALL_GRADE_MASTER_SUCCESS";
export const ALL_GRADE_MASTER_FAIL = "ALL_GRADE_MASTER_FAIL";

//currency master
export const ALL_CURRENCY_MASTER_REQUEST = "ALL_CURRENCY_MASTER_REQUEST";
export const ALL_CURRENCY_MASTER_SUCCESS = "ALL_CURRENCY_MASTER_SUCCESS";
export const ALL_CURRENCY_MASTER_FAIL = "ALL_CURRENCY_MASTER_FAIL";

//currency master
export const ALL_CUT_MASTER_REQUEST = "ALL_CUT_MASTER_REQUEST";
export const ALL_CUT_MASTER_SUCCESS = "ALL_CUT_MASTER_SUCCESS";
export const ALL_CUT_MASTER_FAIL = "ALL_CUT_MASTER_FAIL";

//gst master
export const ALL_GST_MASTER_REQUEST = "ALL_GST_MASTER_REQUEST";
export const ALL_GST_MASTER_SUCCESS = "ALL_GST_MASTER_SUCCESS";
export const ALL_GST_MASTER_FAIL = "ALL_GST_MASTER_FAIL";

//expense type master
export const ALL_EXPENSE_TYPE_MASTER_REQUEST = "ALL_EXPENSE_TYPE_MASTER_REQUEST";
export const ALL_EXPENSE_TYPE_MASTER_SUCCESS = "ALL_EXPENSE_TYPE_MASTER_SUCCESS";
export const ALL_EXPENSE_TYPE_MASTER_FAIL = "ALL_EXPENSE_TYPE_MASTER_FAIL";

//pallete master
export const ALL_PALLETE_MASTER_REQUEST = "ALL_PALLETE_MASTER_REQUEST";
export const ALL_PALLETE_MASTER_SUCCESS = "ALL_PALLETE_MASTER_SUCCESS";
export const ALL_PALLETE_MASTER_FAIL = "ALL_PALLETE_MASTER_FAIL";

//fabricColor master
export const ALL_FABRIC_COLOR_MASTER_REQUEST = "ALL_FABRIC_COLOR_MASTER_REQUEST";
export const ALL_FABRIC_COLOR_MASTER_SUCCESS = "ALL_FABRIC_COLOR_MASTER_SUCCESS";
export const ALL_FABRIC_COLOR_MASTER_FAIL = "ALL_FABRIC_COLOR_MASTER_FAIL";

//party master
export const ALL_PARTY_MASTER_REQUEST = "ALL_PARTY_MASTER_REQUEST";
export const ALL_PARTY_MASTER_SUCCESS = "ALL_PARTY_MASTER_SUCCESS";
export const ALL_PARTY_MASTER_FAIL = "ALL_PARTY_MASTER_FAIL";

//unit master
export const ALL_UNIT_MASTER_REQUEST = "ALL_UNIT_MASTER_REQUEST";
export const ALL_UNIT_MASTER_SUCCESS = "ALL_UNIT_MASTER_SUCCESS";
export const ALL_UNIT_MASTER_FAIL = "ALL_UNIT_MASTER_FAIL";

// item name master
export const ALL_ITEM_NAME_MASTER_REQUEST = "ALL_ITEM_NAME_MASTER_REQUEST";
export const ALL_ITEM_NAME_MASTER_SUCCESS = "ALL_ITEM_NAME_MASTER_SUCCESS";
export const ALL_ITEM_NAME_MASTER_FAIL = "ALL_ITEM_NAME_MASTER_FAIL";

// item Type master
export const ALL_ITEM_CODE_MASTER_REQUEST = "ALL_ITEM_CODE_MASTER_REQUEST";
export const ALL_ITEM_CODE_MASTER_SUCCESS = "ALL_ITEM_CODE_MASTER_SUCCESS";
export const ALL_ITEM_CODE_MASTER_FAIL = "ALL_ITEM_CODE_MASTER_FAIL";

//fabric master
export const ALL_FABRIC_MASTER_REQUEST = "ALL_FABRIC_MASTER_REQUEST";
export const ALL_FABRIC_MASTER_SUCCESS = "ALL_FABRIC_MASTER_SUCCESS";
export const ALL_FABRIC_MASTER_FAIL = "ALL_FABRIC_MASTER_FAIL";

//new supplier master

export const FETCH_ALL_SUPPLIER_MASTER_LIST_REQUEST = "LIST_SUPPLIERS_MASTER_REQUEST";
export const FETCH_ALL_SUPPLIER_MASTER_LIST_SUCCESS = "FETCH_ALL_SUPPLIER_MASTER_LIST_SUCCESS";
export const FETCH_ALL_SUPPLIER_MASTER_FAIL = "FETCH_ALL_SUPPLIER_MASTER_FAIL";

//suplier branches
export const FETCH_ALL_SUPPLIER_MASTER_BRANCHES_LIST_REQUEST = "LIST_SUPPLIERS_MASTER_REQUEST";
export const FETCH_ALL_SUPPLIER_MASTER_BRANCHES_LIST_SUCCESS = "FETCH_ALL_SUPPLIER_MASTER_LIST_SUCCESS";
export const FETCH_ALL_SUPPLIER_MASTER_BRANCHES__FAIL = "FETCH_ALL_SUPPLIER_MASTER_FAIL";

//item category
export const FETCH_ALL_ITEMS_CATEGORY_REQUEST = "FETCH_ALL_ITEMS_CATEGORY_REQUEST";
export const FETCH_ALL_ITEMS_CATEGORY_SUCCESS = "FETCH_ALL_ITEMS_CATEGORY_SUCCESS";
export const FETCH_ALL_ITEMS_CATEGORY_FAIL = "FETCH_ALL_ITEMS_CATEGORY_FAIL";

//item subcategory
export const FETCH_ALL_ITEMS_SUBCATEGORY_REQUEST = "FETCH_ALL_ITEMS_SUBCATEGORY_REQUEST";
export const FETCH_ALL_ITEMS_SUBCATEGORY_SUCCESS = "FETCH_ALL_ITEMS_SUBCATEGORY_SUCCESS";
export const FETCH_ALL_ITEMS_SUBCATEGORY_FAIL = "FETCH_ALL_ITEMS_SUBCATEGORY_FAIL";

//series -master
export const FETCH_ALL_SERIES_REQUEST = "FETCH_ALL_SERIES_REQUEST";
export const FETCH_ALL_SERIES_SUCCESS = "FETCH_ALL_SERIES_SUCCESS";
export const FETCH_ALL_SERIES_FAIL = "FETCH_ALL_SERIES_FAIL";

//DEPARTMENT -master
export const FETCH_ALL_DEPARTMENT_REQUEST = "FETCH_ALL_DEPARTMENT_REQUEST";
export const FETCH_ALL_DEPARTMENT_SUCCESS = "FETCH_ALL_DEPARTMENT_SUCCESS";
export const FETCH_ALL_DEPARTMENT_FAIL = "FETCH_ALL_DEPARTMENT_FAIL";

//MACHINE -master
export const FETCH_ALL_MACHINE_REQUEST = "FETCH_ALL_MACHINE_REQUEST";
export const FETCH_ALL_MACHINE_SUCCESS = "FETCH_ALL_MACHINE_SUCCESS";
export const FETCH_ALL_MACHINE_FAIL = "FETCH_ALL_MACHINE_FAIL";

//CHARACTER -master
export const FETCH_ALL_CHARACTER_REQUEST = "FETCH_ALL_CHARACTER_REQUEST";
export const FETCH_ALL_CHARACTER_SUCCESS = "FETCH_ALL_CHARACTER_SUCCESS";
export const FETCH_ALL_CHARACTER_FAIL = "FETCH_ALL_CHARACTER_FAIL";

//PATTERN -master
export const FETCH_ALL_PATTERN_REQUEST = "FETCH_ALL_PATTERN_REQUEST";
export const FETCH_ALL_PATTERN_SUCCESS = "FETCH_ALL_PATTERN_SUCCESS";
export const FETCH_ALL_PATTERN_FAIL = "FETCH_ALL_PATTERN_FAIL";

//PATTERN -master
export const FETCH_ALL_PROCESS_REQUEST = "FETCH_ALL_PROCESS_REQUEST";
export const FETCH_ALL_PROCESS_SUCCESS = "FETCH_ALL_PROCESS_SUCCESS";
export const FETCH_ALL_PROCESS_FAIL = "FETCH_ALL_PROCESS_FAIL";

//COLOUR -master
export const FETCH_ALL_COLOUR_REQUEST = "FETCH_ALL_COLOUR_REQUEST";
export const FETCH_ALL_COLOUR_SUCCESS = "FETCH_ALL_COLOUR_SUCCESS";
export const FETCH_ALL_COLOUR_FAIL = "FETCH_ALL_COLOUR_FAIL";

//TRANSPORTER -master
export const FETCH_ALL_TRANSPORTER_REQUEST = "FETCH_ALL_TRANSPORTER_REQUEST";
export const FETCH_ALL_TRANSPORTER_SUCCESS = "FETCH_ALL_TRANSPORTER_SUCCESS";
export const FETCH_ALL_TRANSPORTER_FAIL = "FETCH_ALL_TRANSPORTER_FAIL";

//VEHICLE -master
export const FETCH_ALL_VEHICLE_REQUEST = "FETCH_ALL_VEHICLE_REQUEST";
export const FETCH_ALL_VEHICLE_SUCCESS = "FETCH_ALL_VEHICLE_SUCCESS";
export const FETCH_ALL_VEHICLE_FAIL = "FETCH_ALL_VEHICLE_FAIL";

//DISPATCH ADDRESS -master
export const FETCH_ALL_DISPATCH_ADDRESS_REQUEST = "FETCH_ALL_DISPATCH_ADDRESS_REQUEST";
export const FETCH_ALL_DISPATCH_ADDRESS_SUCCESS = "FETCH_ALL_DISPATCH_ADDRESS_SUCCESS";
export const FETCH_ALL_DISPATCH_ADDRESS_FAIL = "FETCH_ALL_DISPATCH_ADDRESS_FAIL";

//PHOTO -master
export const FETCH_ALL_PHOTO_REQUEST = "FETCH_ALL_PHOTO_REQUEST";
export const FETCH_ALL_PHOTO_SUCCESS = "FETCH_ALL_PHOTO_SUCCESS";
export const FETCH_ALL_PHOTO_FAIL = "FETCH_ALL_PHOTO_FAIL";

//PHOTO ALBUM -master
export const FETCH_ALL_PHOTO_ALBUM_REQUEST = "FETCH_ALL_PHOTO_ALBUM_REQUEST";
export const FETCH_ALL_PHOTO_ALBUM_SUCCESS = "FETCH_ALL_PHOTO_ALBUM_SUCCESS";
export const FETCH_ALL_PHOTO_ALBUM_FAIL = "FETCH_ALL_PHOTO_ALBUM_FAIL";

//CUSTOMER -master
export const FETCH_ALL_CUSTOMER_REQUEST = "FETCH_ALL_CUSTOMER_REQUEST";
export const FETCH_ALL_CUSTOMER_SUCCESS = "FETCH_ALL_CUSTOMER_SUCCESS";
export const FETCH_ALL_CUSTOMER_FAIL = "FETCH_ALL_CUSTOMER_FAIL";

//CUSTOMER CLIENT -master
export const FETCH_ALL_CUSTOMER_CLIENT_REQUEST = "FETCH_ALL_CUSTOMER_CLIENT_REQUEST";
export const FETCH_ALL_CUSTOMER_CLIENT_SUCCESS = "FETCH_ALL_CUSTOMER_CLIENT_SUCCESS";
export const FETCH_ALL_CUSTOMER_CLIENT_FAIL = "FETCH_ALL_CUSTOMER_CLIENT_FAIL";

//POLISH -master

export const FETCH_ALL_POLISH_REQUEST = "FETCH_ALL_POLISH_REQUEST";
export const FETCH_ALL_POLISH_SUCCESS = "FETCH_ALL_POLISH_SUCCESS";
export const FETCH_ALL_POLISH_FAIL = "FETCH_ALL_POLISH_FAIL";

//LENGTH -master

export const FETCH_ALL_LENGTH_REQUEST = "FETCH_ALL_LENGTH_REQUEST";
export const FETCH_ALL_LENGTH_SUCCESS = "FETCH_ALL_LENGTH_SUCCESS";
export const FETCH_ALL_LENGTH_FAIL = "FETCH_ALL_LENGTH_FAIL";
//WIDTH -master

export const FETCH_ALL_WIDTH_REQUEST = "FETCH_ALL_WIDTH_REQUEST";
export const FETCH_ALL_WIDTH_SUCCESS = "FETCH_ALL_WIDTH_SUCCESS";
export const FETCH_ALL_WIDTH_FAIL = "FETCH_ALL_WIDTH_FAIL";
//THICKNESS -master

export const FETCH_ALL_THICKNESS_REQUEST = "FETCH_ALL_THICKNESS_REQUEST";
export const FETCH_ALL_THICKNESS_SUCCESS = "FETCH_ALL_THICKNESS_SUCCESS";
export const FETCH_ALL_THICKNESS_FAIL = "FETCH_ALL_THICKNESS_FAIL";

//LENGTH dropdown -master
export const FETCH_ALL_LENGTH_DROPDOWN_REQUEST = "FETCH_ALL_LENGTH_DROPDOWN_REQUEST";
export const FETCH_ALL_LENGTH_DROPDOWN_SUCCESS = "FETCH_ALL_LENGTH_DROPDOWN_SUCCESS";
export const FETCH_ALL_LENGTH_DROPDOWN_FAIL = "FETCH_ALL_LENGTH_DROPDOWN_FAIL";
//WIDTH dropdown -master

export const FETCH_ALL_WIDTH_DROPDOWN_REQUEST = "FETCH_ALL_WIDTH_DROPDOWN_REQUEST";
export const FETCH_ALL_WIDTH_DROPDOWN_SUCCESS = "FETCH_ALL_WIDTH_DROPDOWN_SUCCESS";
export const FETCH_ALL_WIDTH_DROPDOWN_FAIL = "FETCH_ALL_WIDTH_DROPDOWN_FAIL";
//THICKNESS dropdown -master

export const FETCH_ALL_THICKNESS_DROPDOWN_REQUEST = "FETCH_ALL_THICKNESS_DROPDOWN_REQUEST";
export const FETCH_ALL_THICKNESS_DROPDOWN_SUCCESS = "FETCH_ALL_THICKNESS_DROPDOWN_SUCCESS";
export const FETCH_ALL_THICKNESS_DROPDOWN_FAIL = "FETCH_ALL_THICKNESS_DROPDOWN_FAIL";
